import { Tabs, Typography } from 'antd';
import { useLocation, useNavigate } from 'react-router';
import { AutodialerBucketsConfig } from '../autodialer-config-page/autodialer-config-page';
import { Header } from '../header/header';
import AdminAutodialConfig from '../admin-page/components/autodial-config/admin-autodial-config';
import { strings } from '../../lang';
import './autodialer-settings-page.css';

const { Title, Text } = Typography;

type TabKey = 'bucket-config' | 'phone-number-settings';

const tabPaths: Record<TabKey, string> = {
  'bucket-config': '/autodialer-settings/bucket-config',
  'phone-number-settings': '/autodialer-settings/phone-number-settings',
};

const getActiveTab = (pathname: string): TabKey =>
  (Object.entries(tabPaths) as [TabKey, string][]).find(([, path]) => path === pathname)?.[0] ?? 'bucket-config';

export const AutodialerSettingsPage = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const activeTab = getActiveTab(pathname);

  return (
    <>
      <Header />
      <main className="autodialer-settings-page">
        <div className="autodialer-settings-page__heading">
          <Title level={2}>{strings.autodialerSettings.title}</Title>
          <Text type="secondary">{strings.autodialerSettings.description}</Text>
        </div>
        <Tabs
          activeKey={activeTab}
          onChange={(key) => navigate(tabPaths[key as TabKey])}
          items={[
            { key: 'bucket-config', label: strings.autodialerSettings.bucketConfigTab, children: <div className="autodialer-settings-page__tab-content"><AutodialerBucketsConfig /></div> },
            { key: 'phone-number-settings', label: strings.autodialerSettings.phoneNumberSettingsTab, children: <div className="autodialer-settings-page__tab-content"><AdminAutodialConfig /></div> },
          ]}
        />
      </main>
    </>
  );
};
